import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {StepCard} from '@udemy/react-certification-preparation';

import styles from './learning-steps-section.module.less';

export interface Step {
    number: number;
    title: string;
    description: string;
}

export interface LearningStepsSectionProps {
    steps: Step[];
}

export const LearningStepsSection: React.FC<LearningStepsSectionProps> = ({steps}) => {
    const {gettext} = useI18n();

    return (
        <div className={classNames(styles['steps-section'])}>
            <h2 className={styles['section-title']}>{gettext("What you'll learn")}</h2>
            <div className={styles['steps']}>
                {steps
                    .filter((item) => item.description)
                    .map((step, idx) => (
                        <StepCard
                            key={step.title}
                            number={idx + 1}
                            title={step.title}
                            titleColor="default"
                            description={step.description}
                            iconColor="color-purple-100"
                            fullHeight={true}
                        />
                    ))}
            </div>
        </div>
    );
};
